<header>
    <label class="close_button" (click)="close()">x</label>
    <div class="header" style="display:block">
        <h1> {{heading}} </h1>
    </div>
</header>


<div class="body" [style]="errormsg? 'margin: 1% 2% 0% 3%;':  'margin: 1% 2% 4.8% 3%;'">
    <br>
    <div>
        <label class="catlabel">Route Group<span style="color:#ff0000">*</span></label>
        <label *ngIf="eventType=='EDIT'" class="content">{{routeGroup}}</label>
        <input *ngIf="eventType=='ADD'" type="text" class="content" [(ngModel)]="routeGroup">

    </div>
    <div>
        <label class="catlabel">Minimum Connection<span style="color:#ff0000">*</span></label>

        <input type="number" min="0" class="content" [(ngModel)]="minimumConnection">

    </div>
    <div>
        <label class="catlabel">Is FIFO?</label>
        <span class="tickSpan">
            <!-- <img style="cursor:pointer;" class="table_delete" src="./assets/images/noun_tick.svg"
                (click)="toggleTick('isunloadbased')"> -->
            <input type="checkbox" class="checkbox" [(ngModel)]="toggleIsFIFO">
        </span>

    </div>
    <div>
        <label class="catlabel">Is Unload Based?</label>
        <span class="tickSpan">
            <!-- <img style="cursor:pointer;" class="table_delete" src="./assets/images/noun_tick.svg"
                (click)="toggleTick('isunloadbased')"> -->
            <input type="checkbox" class="checkbox" [(ngModel)]="toggleIsUnloadBased">
        </span>

    </div>
    <div>

        <label class=" catlabel">Tier<span style="color:#ff0000">*</span></label>

        <input type="number" min="0" class="content" [(ngModel)]="tierId">


    </div>

</div>


<label *ngIf="errormsg" class="errormsg"> {{errormsg}} </label>
<div class=" footer">
    <button (click)="onNoClick()" class="cancel"
        style="display: inline; background: transparent;border: none !important;"> CANCEL </button>
    <button mat-raised-button class="submit" style="display: inline;" (click)="saveClick()">SAVE</button>
</div>